import React from "react";
import styles from "../RiskAssessments/RiskAssessments.module.scss";
const ErrorCard = ({ icon, title, description, isClientOnboarding }) => {
  return (
    <div className={`${styles["error-card"]}`}>
      <div
        className="bg-white rounded shadow-sm my-5 p-4 d-flex flex-column align-items-center"
        style={{
          animation: "fadeInBounce 1s",
          width: `${isClientOnboarding ? "35vw" : "498px"}`,
        }}
      >
        <div
          style={{
            fontSize: 48,
            color: "#bdbdbd",
            marginBottom: 16,
            animation: "bounce 1.2s infinite",
          }}
        >
          <span role="img" aria-label="info">
            {icon}
          </span>
        </div>
        <div
          className="text-center fw-medium mb-2"
          style={{ color: "#666", fontSize: 16 }}
        >
          {title}
        </div>
        <div
          className="text-center"
          style={{ color: "#999", fontSize: 14, maxWidth: 340 }}
        >
          {description}
        </div>
      </div>
      {/* Animation keyframes */}
      <style>{`
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        @keyframes fadeInBounce {
          0% { opacity: 0; transform: scale(0.95); }
          60% { opacity: 1; transform: scale(1.05); }
          100% { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

export default ErrorCard;
